import { Link } from '@nextui-org/react'
import { forwardRef, type ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'
import SignupBackground from '~/assets/sign-background.png'
import { cm } from '~/utils/utils'
import { LogoIcon } from '../icons'

interface Props {
  children: ReactNode
  className?: string
  isStatic?: boolean
  navigation?: ReactNode
  titleClassName?: string
}

export const SiteLayoutV2 = forwardRef<HTMLDivElement, Props>(
  ({ children, className = '', isStatic = false, navigation, titleClassName }, ref) => {
    return (
      <div>
        <div className='absolute inset-0 z-0 top-0 right-0'>
          <img src={SignupBackground} className='w-screen h-screen object-cover' />
          {/* Dark-mode scrim: the background art is a fixed light gradient, so in
              dark mode we lay a deep neutral wash over it. The wash is slightly
              translucent so a faint hint of the original art still reads through. */}
          <div className='absolute inset-0 hidden bg-[#18181b]/[0.88] dark:block' />
        </div>
        <div
          className={cm(
            'site-layout flex items-center w-screen min-h-screen flex-col z-10',
            isStatic ? '' : 'relative',
            className
          )}
          ref={ref}
        >
          <div className='absolute top-8 left-8 z-50'>
            <Link href='/' className={cm('flex items-center', titleClassName)}>
              <LogoIcon />
            </Link>
            {navigation}
          </div>
          <div
            className={cm(
              'flex-1',
              isStatic ? '' : 'overflow-auto flex flex-col items-center justify-start pt-32'
            )}
          >
            {children}
          </div>
          <Toaster containerStyle={{ zIndex: 99999 }} />
        </div>
      </div>
    )
  }
)
